import React from 'react';
import { isEmpty } from 'lodash';
import DriOperations from '../../actions/driOperations';
import DriModuleForm from '../../components/DriModuleForm';

const DriStatementApproval = () => {
  const processApiRequest = async (
    params,
    { setSuccessMessage, setErrorMessage, setSevereFailureErrorMessage },
  ) => {
    try {
      if (isEmpty(params.selectedContractIds) && isEmpty(params.ignoredContractIds)) {
        setErrorMessage('Please enter at least 1 contractId');
      } else {
        const response = await DriOperations.approveMultipleStatements(params);
        if (response.ok) {
          const { successfulStatements = [], failedStatements = [] } = await response.json();

          if (successfulStatements.length > 0) {
            const successMessages = successfulStatements.map(
              statementSuccessLog =>
                `Contract Id: ${statementSuccessLog.contractId}-Statement Id: ${
                  statementSuccessLog.statementId
                }-Message: ${JSON.stringify(statementSuccessLog.message)}`,
            );
            setSuccessMessage(`Successfully approved ${successMessages.length} Statements`);
            console.log({successMessages}) // eslint-disable-line
          }

          if (failedStatements.length > 0) {
            const failedMessages = failedStatements.map(
              statementErrorLog =>
                `Contract Id: ${statementErrorLog.contractId}\nStatement Id: ${statementErrorLog.statementId}\nError: ${statementErrorLog.error}`,
            );
            const failedList = failedStatements
              .map(x => `${x.contractId}-${x.statementId}`)
              .join('\n\n');
            setErrorMessage(
              `Failed to approve ${failedMessages.length} Statements:\n\n${failedList}`,
            );
          }
          if (successfulStatements.length === 0 && failedStatements.length === 0) {
            setSuccessMessage('No statements were approved because no statements were found');
          }
        } else if (response.error) {
          throw new Error(JSON.stringify(response.error));
        } else {
          throw new Error(`${response.status} ${response.statusText}`);
        }
      }
    } catch (error) {
      setSevereFailureErrorMessage(`${error}`);
    }
  };

  return (
    <>
      <DriModuleForm
        subModuleHeader="Approve Statement for a SELECT list of contractIds"
        buttonText="Approve Statements"
        formId="approve-select-statements"
        onSubmit={async (contractIds, callbacks) =>
          processApiRequest({ selectedContractIds: contractIds }, callbacks)
        }
        inputs={[
          {
            id: 'contractIds',
            label: 'Enter any contract Ids for the statements to be approved',
            type: 'picker',
            config: { pickerSuggestionsProps: { noResultsFoundText: 'Duplicate ContractId' } },
          },
        ]}
      />
      <DriModuleForm
        subModuleHeader="Approve Statements for ALL contractIds EXCEPT the following"
        buttonText="Approve Statements"
        formId="approve-except-statements"
        onSubmit={async (contractIds, callbacks) =>
          processApiRequest({ ignoredContractIds: contractIds }, callbacks)
        }
        inputs={[
          {
            id: 'contractIds',
            label: 'Enter any contract Ids of statements that you do NOT want to approve for',
            type: 'picker',
            config: { pickerSuggestionsProps: { noResultsFoundText: 'Duplicate ContractId' } },
          },
        ]}
      />
    </>
  );
};

export default DriStatementApproval;
